import { EntityType } from '@/modules/entities/types/EntityType';
import { AugmentedUpdateEntityInput } from '@/types/schema';

/**
 * Maps entity type to the corresponding subtype update field in AugmentedUpdateEntityInput.
 * This is used when updating entities with insurance policies.
 *
 * @param entityType
 */
export function getEntitySubtypeUpdateFieldForPolicy(
  entityType: EntityType
): keyof AugmentedUpdateEntityInput | null {
  return INSURANCE_POLICY_ENTITY_TYPE_TO_UPDATE_FIELD[entityType] || null;
}

/**
 * Mapping of entity types that can hold insurance policies to their corresponding
 * update fields in AugmentedUpdateEntityInput.
 */
const INSURANCE_POLICY_ENTITY_TYPE_TO_UPDATE_FIELD: Partial<
  Record<EntityType, keyof AugmentedUpdateEntityInput>
> = {
  'revocable-trust': 'updateRevocableTrust',
  'irrevocable-trust': 'updateIrrevocableTrust',
  ilit: 'updateIlitTrust',
  slat: 'updateSlatTrust',
  clt: 'updateCltTrust',
  crt: 'updateCrtTrust',
  llc: 'updateLlcBusinessEntity',
  lp: 'updateLpBusinessEntity',
  gp: 'updateGpBusinessEntity',
  'c-corp': 'updateCcorpBusinessEntity',
  's-corp': 'updateScorpBusinessEntity',
  daf: 'updateDonorAdvisedFund',
  'private-foundation': 'updatePrivateFoundation',
  'insurance-account': 'updateInsurancePersonalAccount',
};
